export const GESTURE_BLOT_NAME = 'gesture'
export const GESTURE_TAG_NAME = 'gesture'
/**
 * 호환성을 위헤 기존 클래스명 사용
 */
export const GESTURE_CLASS_NAME = 'gestureButton'
export const GESTURE_MODULE_NAME = 'gestureModule'
